// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".give-back-info[data-v-5f6afd02] {\n  font-size: 13px;\n  color: #6a655e;\n}", ""]);
// Exports
module.exports = exports;
